import type { ReactNode } from 'react'
import { SectionCard } from '../patterns'

/** A scrolling padded section-card wrapper for admin tabs that delegate to
 *  a self-contained panel. Shared chrome so every delegated section looks
 *  identical across the global + per-server admin shells. */
export function DelegatedTab({
  icon,
  title,
  subtitle,
  children,
}: {
  icon: ReactNode
  title: string
  subtitle?: string
  children: ReactNode
}) {
  return (
    <div className="min-h-0 flex-1 overflow-y-auto">
      <div className="p-6">
        <SectionCard icon={icon} title={title} subtitle={subtitle}>{children}</SectionCard>
      </div>
    </div>
  )
}
